import { useEffect } from "react";

// eslint-disable-next-line no-unused-vars
type Hook = (content: string) => void;

export const useScript: Hook = content => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = content;
    document.body.appendChild(script);
  }, [content]);
};
